
<template>
  <div
    class="courseDetailsSpecial"
    :class="{ isIosxVideoOut: isIosx, noAppNav: !isToken }"
  >
    <van-sticky>
      <div class="courseDetailsSpecialNav">
        <img
          class="navLeft"
          @click="prev()"
          src="./../../../assets/school/backh.png"
        />
        <span class="navTitle">专栏课程</span>
        <div class="navRight" v-if="isToken && isPower">
          <img
            src="./../../../assets/school/collect.png"
            v-if="!data.is_collection"
            @click="collect(true, data.id)"
          />
          <img
            src="./../../../assets/school/collect5.png"
            v-else
            @click="collect(false, data.id)"
          />
          <img
            class="sf"
            src="./../../../assets/school/sfh.png"
            @click="share()"
          />
        </div>
      </div>
    </van-sticky>
    <div v-if="loaded">
      <div v-if="isPower">
        <div class="courseDetailsSpecialTop">
          <!-- <img :src="data.image" /> -->
          <van-image width="100%" height="100%" fit="cover" :src="data.image" />
        </div>
        <div class="titleTop">
          <h3>{{ data.title }}</h3>
          <p>{{ data.statistics.total_study_num }}次学习</p>
        </div>
        <!-- 阴影 -->
        <div style="height: 10px; background: #f7f8fc"></div>
        <div :class="{ noJoinStudy: !data.is_join_study }">
          <van-tabs
            v-model="specialActive"
            scrollspy
            sticky
            line-width="16px"
            line-height="4px"
            title-inactive-color="#6E727A"
            title-active-color="#404247"
            :offset-top="offsetTop"
          >
            <van-tab title="简介">
              <div class="dec" ref="specialContent">
                <!-- ad -->
                <!-- <div class="ad">
                <img
                  src="http://qualification-qiniu.shall-buy.com/dog20210917114112074757.png"
                />
              </div> -->
                <div class="decMid">
                  <div v-html="data.desc" id="content"></div>
                </div>
                <div class="decBom">
                  <!-- 讲师信息 -->
                  <div
                    class="lecturerInfo"
                    v-if="data.lecturer"
                    @click="toLecturerDetail(data.lecturer.id)"
                  >
                    <img
                      v-if="data.lecturer.head_pic"
                      :src="data.lecturer.head_pic"
                    />
                    <img
                      v-else
                      src="./../../../assets/school/defaultAvatar.png"
                    />
                    <div class="lecturerInfoMid">
                      <h3>{{ data.lecturer.name }}</h3>
                      <p>{{ data.lecturer.desc }}</p>
                    </div>
                    <div
                      @click.stop="attention(data.lecturer.id)"
                      v-if="!data.is_fans && isToken"
                      class="lecturerInfoAttention"
                    >
                      <img src="./../../../assets/school/add.png" />
                      <span>关注</span>
                    </div>
                    <img
                      v-else
                      src="./../../../assets/school/right.png"
                      style="width: 12px; height: 12px"
                    />
                  </div>
                  <!-- 阴影 -->
                  <div
                    style="height: 10px; background: #f7f8fc; margin-top: 24px"
                  ></div>
                </div>
              </div>
            </van-tab>
            <van-tab title="目录">
              <div class="catalogue">
                <div
                  class="catalogueItem"
                  v-for="(item, index) in catalogueList"
                  :key="index"
                  @click="toCourseDetails(item.id, item.type)"
                >
                  <!-- <img :src="item.image" class="catalogueItemLeft" /> -->
                  <div class="catalogueItemLeft">
                    <van-image
                      width="100%"
                      height="100%"
                      radius="4px"
                      fit="cover"
                      :src="item.image"
                    />
                  </div>
                  <div class="catalogueItemMid">
                    <p>{{ item.title }}</p>
                    <div>
                      <img
                        src="./../../../assets/school/unselected2.png"
                        v-if="item.type == 2"
                      />
                      <img
                        src="./../../../assets/school/unselected3.png"
                        v-if="item.type == 3"
                      />
                      <img
                        src="./../../../assets/school/unselected4.png"
                        v-if="item.type == 4"
                      />
                      <span>{{ item.sort_num }}</span>
                    </div>
                  </div>
                  <span class="catalogueItemRight">
                    <img
                      v-if="
                        !data.is_join_study &&
                        (item.try_see != 0 || item.try_content != '')
                      "
                      src="./../../../assets/school/trysee.png"
                    />
                    <van-circle
                      v-if="data.is_join_study"
                      v-model="item.percentage"
                      :rate="item.percentage"
                      layer-color="#FAF2E6"
                      color="#E4C083"
                      size="18px"
                      :stroke-width="200"
                    />
                    <span v-if="data.is_join_study">{{
                      item.percentage == 0 ? "去学习" : item.percentage + "%"
                    }}</span>
                  </span>
                </div>
              </div>
            </van-tab>
          </van-tabs>
          <!-- 没有更多 -->
          <div
            style="
              background: #f7f8fc;
              margin-top: 32px;
              text-align: center;
              font-size: 14px;
              color: #9ca1ad;
              padding: 48px 0 58px;
            "
          >
            没有更多了
          </div>
        </div>

        <div class="btmdiv" v-if="!data.is_join_study && isToken">
          <span @click="joinStudy()">加入学习</span>
        </div>
      </div>
      <!-- 无权限 -->
      <div v-else class="noPower">
        <img src="./../../../assets/school/dataTip.png" />
        <p>课程数据丢失</p>
      </div>
    </div>
    <div v-else class="loading">
      <img src="./../../../assets/school/loading.gif" />
      <p>加载中</p>
    </div>
    <SfBtm :mobile="mobile" v-if="!isToken && mobile"></SfBtm>
    <span class="shareTip" v-if="!isToken && mobile"
      >{{ mobile.substring(0, 3) + "****" + mobile.substring(7) }}的分享</span
    >
  </div>
</template>

<script>
import SfBtm from "./../components/sfBtm.vue";
export default {
  data() {
    return {
      isIosx: false,
      loaded: false,
      id: "",
      columnDetailUrl: "school/index/column/detail",
      catalogueUrl: "school/index/column/courses",
      channel: 1,
      isToken: false,
      data: {},
      catalogueList: [],
      specialActive: 0,
      isIOS: false,
      isWeixin: false,
      isQQ: false,
      isPower: false,
      offsetTop: "71px",
      mobile: "",
    };
  },
  components: { SfBtm },
  mounted() {
    this.isIosx = this.isIphoneX();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    // 判断是否预览返回
    if (
      localStorage.getItem("filePreview") &&
      localStorage.getItem("filePreview") == "true"
    ) {
      this.showDownload = true;
      localStorage.setItem("filePreview", "");
    }
    // 判断是否预览返回
    if (
      localStorage.getItem("filePreview") &&
      localStorage.getItem("filePreview") == "true"
    ) {
      this.showDownload = true;
      localStorage.setItem("filePreview", "");
    }
    if (this.$route.query.channel) {
      this.channel = this.$route.query.channel;
    }
    if (JSON.parse(sessionStorage.getItem("token"))) {
      this.isToken = true;
      this.columnDetailUrl = "school/member/column/detail";
      this.catalogueUrl = "school/member/column/courses";
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
      this.getMobile();
    } else {
      this.isToken = false;
      this.catalogueUrl = "school/index/column/courses";
      this.columnDetailUrl = "school/index/column/detail";
      var u = navigator.userAgent;
      this.isWeixin = u.toLowerCase().indexOf("micromessenger") !== -1; // 微信内
      this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (
        u.toLowerCase().indexOf("qq") > -1 &&
        u.toLowerCase().indexOf("mqqbrowser") < 0 &&
        this.isIOS
      ) {
        //qq内置浏览器
        this.isQQ = true;
      }
      if (this.$route.query.mobile) {
        this.mobile = this.$route.query.mobile;
        sessionStorage.setItem("mobile", this.mobile);
      } else {
        this.mobile = sessionStorage.getItem("mobile");
      }
    }
    if (this.isToken) {
      if (this.isIosx) {
        this.offsetTop = "77px";
      } else {
        this.offsetTop = "71px";
      }
    } else {
      this.offsetTop = "48px";
    }
    this.getData();
    this.getCatalogueData();
  },
  methods: {
    prev() {
      this.$router.go(-1);
    },
    // 滚动到目录
    scrollToDirectory() {
      let specialContent = this.$refs.specialContent;
      window.scrollTo(0, specialContent.offsetHeight + 346);
      setTimeout(() => {
        this.specialActive = 1;
      }, 10);
    },
    // 获取专栏详情
    getData() {
      this.$api
        .get(this.columnDetailUrl, {
          id: this.id,
        })
        .then((res) => {
          this.data = res;
          this.isPower = true;
          this.loaded = true;
          if (this.data.is_join_study) {
            setTimeout(() => {
              this.scrollToDirectory();
            }, 0);
          }
          // 改变三方链接地址
          setTimeout(() => {
            this.replayAMethod();
          }, 500);
        })
        .catch((res) => {
          if (res.code == 4000006 || res.code == 4000199) {
            // console.log("无权限访问");
            this.isPower = false;
            this.loaded = true;
          }
        });
    },
    // 获取专栏目录
    getCatalogueData() {
      this.$api
        .get(this.catalogueUrl, {
          parent_id: this.id,
        })
        .then((res) => {
          this.catalogueList = res.list;
        });
    },
    // 加入学习
    joinStudy() {
      this.$api
        .post("school/member/add/study", {
          courses_id: this.id,
        })
        .then((res) => {
          this.data.is_join_study = true;
          this.$toast("加入成功！");
        });
    },
    // 收藏
    collect(type) {
      if (type) {
        this.$api
          .post("school/member/add/collection", {
            courses_id: this.id,
          })
          .then((res) => {
            this.$toast("收藏成功！");
            this.data.is_collection = true;
          });
      } else {
        this.$api
          .post("school/member/cancel/collection", {
            courses_ids: [this.id],
          })
          .then((res) => {
            this.$toast("取消成功！");
            this.data.is_collection = false;
          });
      }
    },
    // 关注
    attention(lecturer_id) {
      this.$api
        .post("school/member/add/fans", {
          lecturer_id: lecturer_id,
        })
        .then((res) => {
          this.data.is_fans = true;
          this.$toast("关注成功！");
        });
    },
    // 进入讲师详情
    toLecturerDetail(id) {
      this.$router.push({
        path: "/school/lecturerDetails",
        query: {
          id: id,
        },
      });
    },
    // 进入课程详情
    toCourseDetails(id, type) {
      let path;
      switch (type) {
        case 2:
          path = "/school/courseDetailsVideo";
          break;
        case 3:
          path = "/school/courseDetailsPicture";
          break;
        case 4:
          path = "/school/courseDetailsAudio";
          break;
        default:
        // console.log(type);
      }
      this.$router.push({
        path: path,
        query: {
          id: id,
          channel: 1,
          type: type,
        },
      });
    },
    // 获取会员手机号
    getMobile() {
      this.$api.get("school/member/share/mobile").then((res) => {
        this.mobile = res.mobile;
      });
    },
    share() {
      if (this.data.all_role == 1) {
        this.$api.post("school/index/business/school/get/share").then((res) => {
          let title = res.small_title;
          let bigTitle = this.data.title;
          let thumb = res.image;
          let url = `${location.href}&mobile=${this.mobile}`;
          let paramAndroid = [bigTitle, title, url, thumb];
          let paramIos = [title, bigTitle, url, thumb];
          this.params(paramIos, JSON.stringify(paramAndroid), "toShare");
        });
      } else {
        this.$toast("该课程非公开，不支持分享哦~");
      }
    },
    // 重定义三方地址
    replayAMethod(e) {
      let content = document.getElementById("content");
      //获取v-html中的所有a标签，返回一个类数组
      let aList = content.getElementsByTagName("a");
      aList = Array.from(aList);
      aList.forEach((item, i) => {
        // 阻止自动跳转
        item.onclick = (e) => {
          if (e && e.preventDefault) {
            //阻止默认浏览器动作(W3C)
            e.preventDefault();
          } else {
            //IE中阻止函数器默认动作的方式
            window.event.returnValue = false;
            return false;
          }
          let url = item.getAttribute("href");
          // 跳转至指定页面
          this.$router.push({
            path: "/school/tripartiteLink",
            query: {
              url: url,
            },
          });
        };
      });
    },
  },
};
</script>

<style>
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.loading img {
  width: 80px;
  height: 80px;
  margin: 200px 0 0;
}
.loading p {
  font-size: 12px;
  color: #9ca1ad;
}

.courseDetailsSpecial {
  width: 100%;
  height: 100%;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  left: 0;
  top: 0;
}
.courseDetailsSpecialNav {
  color: #404247;
  width: 100%;
  height: 22px;
  padding-bottom: 11px;
  padding-top: 38px;
  position: relative;
  background-color: #ffffff;
}
.courseDetailsSpecialNav .navLeft {
  width: 24px;
  height: 24px;
  position: absolute;
  left: 16px;
}
.courseDetailsSpecialNav .navTitle {
  font-size: 17px;
  font-weight: 700;
  color: #404247;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.courseDetailsSpecialNav .navRight {
  display: flex;
  align-items: flex-end;
  position: absolute;
  right: 16px;
}
.courseDetailsSpecialNav .navRight img {
  width: 24px;
  height: 24px;
}
.courseDetailsSpecialNav .navRight .sf {
  width: 40px;
  height: 31px;
  margin-left: 8px;
}
/* 上方图片 */
.courseDetailsSpecialTop {
  height: 250px;
}
/* .courseDetailsSpecialTop img {
  width: 100%;
  height: 100%;
} */
/* 标题 */
.titleTop {
  padding: 16px;
  background: url("./../../../assets/school/coursebg.png") no-repeat 0 0;
  background-size: cover;
}
.titleTop h3 {
  margin: 0;
  font-size: 18px;
  color: #404247;
}
.titleTop p {
  font-size: 12px;
  color: #6e727a;
  margin-top: 8px;
}
/* 内容 */
.courseDetailsSpecial .van-tab--active {
  font-weight: 700;
}
.van-tabs__line {
  background: linear-gradient(90deg, #4e7df7 0%, #86b4fc 100%);
  bottom: 19px;
}
.courseDetailsSpecial .van-tabs__wrap {
  display: flex;
  justify-content: center;
  background-color: #ffffff;
}
.courseDetailsSpecial .van-tabs__nav {
  width: 120px;
}
.courseDetailsSpecial .van-tab {
  flex: 1;
  font-size: 15px;
}

/* 简介 */
.noJoinStudy {
  padding-bottom: 60px;
}
.courseDetailsSpecial .dec {
  margin-top: 24px;
}
.courseDetailsSpecial .ad {
  margin: 0 16px;
  height: 72px;
  border-radius: 4px;
  overflow: hidden;
}
.dec .ad img {
  width: 100%;
  height: 100%;
}
.decMid {
  margin: 20px 16px 24px;
  color: #404247;
}
.decMid p {
  word-break: break-all;
  font-size: 15px;
  line-height: 25px;
}
.decBom {
  /* margin: 0 16px; */
}
.courseDetailsSpecial .lecturerInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  background-color: #f6f8fd;
  border-radius: 8px;
  margin: 24px 16px 0px;
  padding: 0 16px;
}
.decBom .lecturerInfo img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: #ffffff;
}
.decBom .lecturerInfo h3 {
  font-size: 15px;
  font-weight: 700;
  color: #404247;
  margin: 0;
}
.decBom .lecturerInfo p {
  font-size: 12px;
  color: #9ca1ad;
  margin: 4px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
.decBom .lecturerInfo .lecturerInfoMid {
  flex: 1;
  margin: 0 8px;
}
.decBom .lecturerInfo .lecturerInfoAttention {
  width: 80px;
  height: 30px;
  background-color: #ffffff;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  color: #4e7df7;
  font-size: 13px;
}
.decBom .lecturerInfo div img {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}

/* 目录 */
.catalogue {
  padding: 24px 16px 0;
}
.catalogueItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.catalogueItemLeft {
  width: 84px;
  height: 56px;
  /* border-radius: 4px; */
}
.catalogueItemMid {
  flex: 1;
  margin: 0 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 56px;
}
.catalogueItemMid p {
  font-size: 14px;
  font-weight: 400;
  color: #404247;
  line-height: 20px;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
.catalogueItemMid div {
  font-size: 12px;
  color: #9ca1ad;
  display: flex;
  align-items: center;
}
.catalogueItemMid div img {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}
.catalogueItemRight {
  width: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #e4c083;
  font-size: 10px;
}
.catalogueItemRight img {
  width: 22px;
  height: 34px;
}
.catalogueItemRight > span {
  transform: scale(0.8);
}

.noPower {
  margin: 0 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.noPower img {
  width: 235px;
  height: 235px;
}
.noPower p {
  margin-top: 24px;
  font-size: 14px;
  color: #9ca1ad;
}

.btmdiv {
  width: 100%;
  height: 83px;
  background: #ffffff;
  box-shadow: 10px 0px 1px 1px #eeeeee;
  position: fixed;
  left: 0;
  bottom: 0;
}
.btmdiv span {
  margin: 4px 16px 0;
  display: block;
  height: 46px;
  line-height: 46px;
  text-align: center;
  background: linear-gradient(90deg, #f6e7b9 0%, #e4c083 100%);
  border-radius: 25px;
  font-size: 15px;
  font-weight: 700;
  color: #94692a;
}

.isIosxVideoOut .courseDetailsSpecialNav {
  padding-top: 44px;
}
.noAppNav .courseDetailsSpecialNav {
  padding-top: 15px !important;
}
.shareTip {
  position: fixed;
  top: 7px;
  right: 0;
  padding: 8px 16px 8px 24px;
  background: rgba(14, 14, 14, 0.36);
  border-radius: 18px 0px 0px 18px;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  z-index: 999;
}
</style>